const breadCrumb = "Lotação de Servidores - Manutenção do Servidor";

const routes = [
  {
    path: "/servidor/:servidorId/manutencao-de-informacoes-do-servidor",
    name: "manutencao-de-informacoes-do-servidor",
    meta: {
      allowedPermissions: ["habilitacao_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/ManutencaoDeInformacoesDoServidor/ManutencaoDeInformacoesDoServidorHome.vue"
      ),
  },
  {
    path: "/servidor/:servidorId/manutencao-de-informacoes-do-servidor/novo",
    name: "manutencao-de-informacoes-do-servidor-novo",
    meta: {
      allowedPermissions: ["habilitacao_insert"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/ManutencaoDeInformacoesDoServidor/ManutencaoDeInformacoesDoServidorCad.vue"
      ),
  },
  {
    path: "/servidor/:servidorId/manutencao-de-informacoes-do-servidor/editar/:id",
    name: "manutencao-de-informacoes-do-servidor-editar",
    meta: {
      allowedPermissions: ["habilitacao_update"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/ManutencaoDeInformacoesDoServidor/ManutencaoDeInformacoesDoServidorEdit.vue"
      ),
  },
  {
    path: "/servidor/:servidorId/manutencao-de-informacoes-do-servidor/visualizar/:id",
    name: "manutencao-de-informacoes-do-servidor-visualizar",
    meta: {
      allowedPermissions: ["habilitacao_show"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/ManutencaoDeInformacoesDoServidor/ManutencaoDeInformacoesDoServidorShow.vue"
      ),
  },
];

export default routes;
